import { memo } from 'react';

type Props = {
  top: number;
  left: number;
  label: string;
  href: string;
  onClose: () => void;
  onEdit: () => void;
  onRemove: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
};

export const LinkTooltip = memo(
  ({
    top,
    left,
    label,
    href,
    onClose,
    onEdit,
    onRemove,
    onMouseEnter,
    onMouseLeave,
  }: Props) => (
    <div
      className="absolute z-10 min-w-[260px] max-w-[320px] rounded-xl bg-[rgba(0,0,0,0.96)] px-3.5 py-3 shadow-[0_12px_30px_rgba(0,0,0,0.25)]"
      style={{ top, left }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="mb-2 flex items-center justify-between text-sm font-medium leading-5 text-white">
        <span>{label}</span>
        <button
          className="cursor-pointer border-none bg-transparent text-center text-xl leading-5 text-white"
          onMouseDown={(e) => e.preventDefault()}
          onClick={onClose}
          data-link-tooltip="true"
          type="button"
        >
          ×
        </button>
      </div>
      <div className="mb-3 break-all text-sm font-normal leading-5 text-[#D2B9FF]">
        {href}
      </div>
      <div className="flex gap-4 text-sm font-medium leading-5">
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-center text-[#936DD8]"
          onMouseDown={(e) => e.preventDefault()}
          onClick={onEdit}
          data-link-tooltip="true"
          type="button"
        >
          Edit
        </button>
        <button
          className="cursor-pointer border-none bg-transparent p-0 text-center text-[#DA0000]"
          onMouseDown={(e) => e.preventDefault()}
          onClick={onRemove}
          data-link-tooltip="true"
          type="button"
        >
          Remove
        </button>
      </div>
    </div>
  ),
);

LinkTooltip.displayName = 'LinkTooltip';
